module.exports = __webpack_public_path__ + "img/remark.caa04aa5.png";